export const TOGGLE_SUB1 = "TOGGLE_SUB1";
export const TOGGLE_SUB2 = "TOGGLE_SUB2";
export const TOGGLE_SUB3 = "TOGGLE_SUB3";
export const ENABLE_MOBILE_SEARCH_BAR = "ENABLE_MOBILE_SEARCH_BAR";
export const DISABLE_MOBILE_SEARCH_BAR = "DISABLE_MOBILE_SEARCH_BAR";
export const ENABLE_DESKTOP_SEARCH_BAR = "ENABLE_DESKTOP_SEARCH_BAR";
export const SET_SEARCH_BAR = "SET_SEARCH_BAR";
export const RESET_SEARCH_BAR = "RESET_SEARCH_BAR";
export const SET_INPUT = "SET_INPUT";
export const DISABLE_DESKTOP_SEARCH_BAR = "DISABLE_DESKTOP_SEARCH_BAR";
export const DEACTIVATE_SUB_MENUS = "DEACTIVATE_SUB_MENUS";
export const ADD_TO_BASKET = "ADD_TO_BASKET";
export const CHANGE_SIZE = "CHANGE_SIZE";
export const ADD_TO_BASKET_ERROR = "ADD_TO_BASKET_ERROR";
export const ADD_ITEM = "ADD_ITEM";
export const DELETE_ALL = "DELETE_ALL";
export const DELETE_SELECTED = "DELETE_SELECTED";
export const DELETE_LIKED = "DELETE LIKED";
export const DELETE_BASKET_ITEM = "DELETE_BASKET_ITEM";
export const DELETE_BASKET_ITEM_ERROR = "DELETE_BASKET_ITEM_ERROR";
export const CHANGE_SIZE_ERROR = "CHANGE_SIZE_ERROR";
export const SET_LIKED = "SET_LIKED";
export const SET_ALERT = "SET_ALERT";
export const REMOVE_ALERT = "REMOVE_ALERT";
export const GET_EMAIL = "GET_EMAIL";
export const CHECK_EMAIL = "CHECK_EMAIL";
export const BUY_PRODUCTS = "BUY_PRODUCTS";
export const BUY_PRODUCTS_ERROR = "BUY_PRODUCTS_ERROR";
export const REGISTER_SUCCESS = "REGISTER_SUCCESS";
export const UPDATE_USER = "UPDATE_USER";
export const DELETE_USER = "DELETE_USER";
export const DELETE_ERROR = "DELETE_ERROR";
export const EMPTY_BASKET = "EMPTY_BASKET";
export const REGISTER_FAIL = "REGISTER_FAIL";
export const USER_LOADED = "USER_LOADED";
export const AUTH_ERROR = "AUTH_ERROR";
export const LOGIN_SUCCESS = "LOGIN_SUCCESS";
export const LOGIN_FAIL = "LOGIN_FAIL";
export const LOGOUT = "LOGOUT";
export const CLEAR_ERRORS = "CLEAR_ERRORS";
export const CHECKOUT = "CHECKOUT";
export const PAYMENT = "PAYMENT";
export const PAYMENT_ERROR = "PAYMENT_ERROR";
export const GET_ALL_DATA = "GET_ALL_DATA";
export const GET_DATA = "GET_DATA";
export const GET_ITEM = "GET_ITEM";
export const GET_UNDER_PRICE = "GET_UNDER_PRICE";
export const DATA_ERROR = "DATA_ERROR";
export const FIND_DATA = "FIND_DATA";
export const UPDATE_DATA = "UPDATE_DATA";
export const CLEAR_DATA = "CLEAR DATA";
